export const APP_VERSION = '0.0.635.20261103201012';
